import React, { useState, useEffect, useContext, useMemo } from "react";
import axios from "axios";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { API, AuthContext } from "../App";
import { toast } from "sonner";
import { exportDailyReportsExcel } from "../utils/excel/exportDailyReports";

import {
    Plus,
    Calendar,
    Edit,
    Trash2,
    Fuel,
    AlertTriangle,
    Search,
    Filter,
    Tractor,
    Truck,
    Eye,
    Users,
    Clock3,
    Droplets,
    MapPin,
    BarChart3,
    ClipboardList
} from "lucide-react";

import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogTrigger
} from "../components/ui/dialog";

import { Button } from "../components/ui/button";

const DailyReports = () => {

    const { user } = useContext(AuthContext);

    const [reports, setReports] = useState([]);
    const [machinery, setMachinery] = useState([]);
    const [operators, setOperators] = useState([]);
    const [users, setUsers] = useState([]);
    const [projects, setProjects] = useState([]);
    const [fuelTanks, setFuelTanks] = useState([]);
    const [selectedMachineryData, setSelectedMachineryData] = useState(null);
    const availableFuelTanks = useMemo(() => {
    if (!selectedMachineryData) return [];

    return fuelTanks.filter(
        tank => tank.fuel_type === selectedMachineryData.fuel_type
    );
}, [fuelTanks, selectedMachineryData]);

    const [loading, setLoading] = useState(true);

    const [dialogOpen, setDialogOpen] = useState(false);
    const [editingReport, setEditingReport] = useState(null);
    const [viewingReport, setViewingReport] = useState(null);

    // FOTOGRAFÍAS DE EVIDENCIA
    const [horometerPhoto, setHorometerPhoto] = useState(null);
    const [workPhoto, setWorkPhoto] = useState(null);

    const [existingHorometerPhoto, setExistingHorometerPhoto] = useState("");
    const [existingWorkPhoto, setExistingWorkPhoto] = useState("");



    const [search, setSearch] = useState("");
    const [selectedMachine, setSelectedMachine] = useState("");
    const [selectedOperator, setSelectedOperator] = useState("");
    const [selectedDate, setSelectedDate] = useState("");
    const [sortBy, setSortBy] = useState("date_desc");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");

const today = new Date();
today.setMinutes(today.getMinutes() - today.getTimezoneOffset());
const [viewMode, setViewMode] = useState("day");

const [currentDate, setCurrentDate] = useState(
    today.toISOString().split("T")[0]
);
const changeDay = (days) => {

    const d = new Date(currentDate + "T00:00:00");

    d.setDate(d.getDate() + days);

    setCurrentDate(d.toISOString().split("T")[0]);

    setViewMode("day");

};

const goToday = () => {

    const today = new Date();

    today.setMinutes(today.getMinutes() - today.getTimezoneOffset());

    setCurrentDate(today.toISOString().split("T")[0]);

    setViewMode("day");

};
    const [formData, setFormData] = useState({
        machinery_id: "",
        operator_id: "",
        project_id: "",
        date: today.toISOString().split("T")[0],

        // HORÓMETRO
        start_hours: 0,
        end_hours: 0,
        hours_worked: 0,

        // COMBUSTIBLE
        diesel_consumed: 0,
        fuel_tank_id: "",

        // LUBRICANTES Y FLUIDOS
        oil_consumed: 0,
        engine_oil_consumed: 0,
        transmission_oil_consumed: 0,
        differential_oil_consumed: 0,
        hydraulic_oil_consumed: 0,
        coolant_consumed: 0,
        grease_consumed: 0,
        other_fluid_consumed: 0,

        // OPERACIÓN
        work_description: "",
        location: "",
        observations: "",

        // TIPO DE TRABAJO
        work_type: "",

        // ESTADO DE LA MÁQUINA
        machine_status: "",

        // CHECKLIST
        checklist: [],

        // NOVEDADES / PARADAS
        has_downtime: false,
        downtime_reason: "",
        downtime_hours: 0
    });

    useEffect(() => {
        fetchData();
    }, []);
    useEffect(() => {
    if (availableFuelTanks.length === 1) {
        setFormData(prev => ({
            ...prev,
            fuel_tank_id: availableFuelTanks[0].id
        }));
    }
}, [availableFuelTanks]);

    const fetchData = async () => {

        const debugStart = performance.now();
        console.log("[DailyReports] fetchData INICIO");

        try {

            const [
    reportsRes,
    machineryRes,
    operatorsRes,
    usersRes,
    branchesRes,
    tanksRes
] = await Promise.all([
    axios.get(`${API}/daily-reports`),
    axios.get(`${API}/machinery/summary`),
    axios.get(`${API}/operators`),
    axios.get(`${API}/users`),
    axios.get(`${API}/branches?company_id=${user.company_id}`),
    axios.get(`${API}/fuel/tanks`)
]);

            setReports(reportsRes.data);
            setMachinery(machineryRes.data);
            setOperators(operatorsRes.data);
            setUsers(usersRes.data);
            setProjects(branchesRes.data);
            setFuelTanks(
    tanksRes.data.filter(
        tank => tank.current_stock > 0
    )
);
            setFormData(prev => ({
    ...prev,
    operator_id: user.id
}));

            console.log(
                "[DailyReports] fetchData DATOS CARGADOS:",
                Math.round(performance.now() - debugStart),
                "ms",
                {
                    reports: reportsRes.data?.length,
                    machinery: machineryRes.data?.length,
                    operators: operatorsRes.data?.length,
                    users: usersRes.data?.length,
                    projects: branchesRes.data?.length,
                    tanks: tanksRes.data?.length
                }
            );

        } catch (error) {

            console.error(
                "[DailyReports] fetchData ERROR:",
                error
            );

            toast.error("Error al cargar datos");

        } finally {

            setLoading(false);

            console.log(
                "[DailyReports] fetchData FIN:",
                Math.round(performance.now() - debugStart),
                "ms"
            );

        }

    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        const initialHours = Number(
            formData.start_hours || 0
        );

        const finalHours = Number(
            formData.end_hours || 0
        );

        const workedHours = Number(
            (finalHours - initialHours).toFixed(1)
        );

        if (!formData.machinery_id) {
            toast.error("Seleccione una maquinaria.");
            return;
        }

        if (finalHours <= initialHours) {
            toast.error(
                "El horómetro final debe ser mayor al inicial."
            );
            return;
        }

        if (workedHours <= 0) {
            toast.error(
                "Las horas trabajadas deben ser mayores a 0."
            );
            return;
        }

        try {

            const payload = {
                ...formData,

                operator_id: user.id,

                start_hours: initialHours,
                end_hours: finalHours,
                hours_worked: workedHours,

                oil_consumed: Number(
                    formData.engine_oil_consumed || 0
                )
            };

            let reportId;

            if (editingReport) {

                const response = await axios.put(
                    `${API}/daily-reports/${editingReport.id}`,
                    payload
                );

                reportId = response.data.id || editingReport.id;

                toast.success("Parte actualizado");

            } else {

                const response = await axios.post(
                    `${API}/daily-reports`,
                    payload
                );

                reportId = response.data.id;

                toast.success("Parte creado");

            }

            // ====================================================
            // FOTOGRAFÍAS DE EVIDENCIA
            // ====================================================

            if (reportId && horometerPhoto) {

                const photoData = new FormData();
                photoData.append("file", horometerPhoto);

                await axios.post(
                    `${API}/daily-reports/${reportId}/evidence/horometer`,
                    photoData
                );
            }

            if (reportId && workPhoto) {

                const photoData = new FormData();
                photoData.append("file", workPhoto);

                await axios.post(
                    `${API}/daily-reports/${reportId}/evidence/work`,
                    photoData
                );
            }

            setDialogOpen(false);
            resetForm();
            setHorometerPhoto(null);
            setWorkPhoto(null);
            fetchData();

        } catch (err) {

            toast.error(
                err.response?.data?.detail ||
                "Error al guardar"
            );

        }

    };

    const handleViewReport = async (report) => {
        try {
            const response = await axios.get(
                `${API}/daily-reports/${report.id}`
            );

            setViewingReport(response.data);

            // Las fotografías se cargan aparte para no bloquear la apertura del detalle.
            try {
                const evidenceResponse = await axios.get(
                    `${API}/daily-reports/${report.id}/evidence`
                );

                setViewingReport(prev => prev ? ({
                    ...prev,
                    horometer_photo: evidenceResponse.data?.horometer_photo || "",
                    work_photo: evidenceResponse.data?.work_photo || ""
                }) : prev);

            } catch (evidenceError) {
                console.error(
                    "[DailyReports] Error cargando fotografías:",
                    evidenceError
                );
            }

        } catch (error) {
            console.error("[DailyReports] Error cargando detalle:", error);
            toast.error(
                error.response?.data?.detail ||
                "No se pudo cargar el detalle del parte"
            );
        }
    };

    const handleDelete = async (id) => {

        if (!window.confirm("¿Eliminar este parte?")) return;

        try {

            await axios.delete(

                `${API}/daily-reports/${id}`

            );

            toast.success("Parte eliminado");

            fetchData();

        } catch {

            toast.error("Error al eliminar");

        }

    };

    const openEditDialog = async (report) => {

        try {
            const response = await axios.get(
                `${API}/daily-reports/${report.id}`
            );

            report = response.data;

        } catch (error) {
            console.error(
                "[DailyReports] Error cargando parte para editar:",
                error
            );

            toast.error(
                error.response?.data?.detail ||
                "No se pudo cargar el parte para editar"
            );

            return;
        }

        setEditingReport(report);

        setHorometerPhoto(null);
        setWorkPhoto(null);
        setExistingHorometerPhoto("");
        setExistingWorkPhoto("");

        const machine = machinery.find(
            m => String(m.id) === String(report.machinery_id)
        );

        setSelectedMachineryData(
            machine || null
        );

        const initialHours = Number(
            report.start_hours || 0
        );

        const finalHours = Number(
            report.end_hours ??
            (
                initialHours +
                Number(report.hours_worked || 0)
            )
        );

        setFormData({
            machinery_id: report.machinery_id || "",
            operator_id: report.operator_id || user.id,
            project_id: report.project_id || "",
            date: report.date || "",
            start_hours: initialHours,
            end_hours: finalHours,
            hours_worked: Number(report.hours_worked || 0),
            diesel_consumed: Number(report.diesel_consumed || 0),
            fuel_tank_id: report.fuel_tank_id || "",
            oil_consumed: Number(report.oil_consumed || 0),
            engine_oil_consumed: Number(report.engine_oil_consumed || 0),
            transmission_oil_consumed: Number(report.transmission_oil_consumed || 0),
            differential_oil_consumed: Number(report.differential_oil_consumed || 0),
            hydraulic_oil_consumed: Number(report.hydraulic_oil_consumed || 0),
            coolant_consumed: Number(report.coolant_consumed || 0),
            grease_consumed: Number(report.grease_consumed || 0),
            other_fluid_consumed: Number(report.other_fluid_consumed || 0),
            work_description: report.work_description || "",
            location: report.location || "",
            observations: report.observations || "",
            work_type: report.work_type || "",
            machine_status: report.machine_status || "",
            checklist: Array.isArray(report.checklist)
                ? report.checklist
                : [],
            has_downtime: Boolean(report.has_downtime),
            downtime_reason: report.downtime_reason || "",
            downtime_hours: Number(report.downtime_hours || 0)
        });

        setDialogOpen(true);

        // Las fotografías se cargan aparte y no bloquean la apertura del formulario.
        try {
            const evidenceResponse = await axios.get(
                `${API}/daily-reports/${report.id}/evidence`
            );

            setExistingHorometerPhoto(
                evidenceResponse.data?.horometer_photo || ""
            );

            setExistingWorkPhoto(
                evidenceResponse.data?.work_photo || ""
            );

        } catch (evidenceError) {
            console.error(
                "[DailyReports] Error cargando fotografías para editar:",
                evidenceError
            );
        }
    };

    const resetForm = () => {

        const today = new Date();

        today.setMinutes(
            today.getMinutes() -
            today.getTimezoneOffset()
        );

        setFormData({

            machinery_id: "",
            operator_id: user.id,
            project_id: "",

            date:
                today.toISOString().split("T")[0],

            start_hours: 0,
            end_hours: 0,
            hours_worked: 0,

            diesel_consumed: 0,
            fuel_tank_id: "",

            oil_consumed: 0,

            engine_oil_consumed: 0,
            transmission_oil_consumed: 0,
            differential_oil_consumed: 0,
            hydraulic_oil_consumed: 0,
            coolant_consumed: 0,
            grease_consumed: 0,
            other_fluid_consumed: 0,

            location: "",
            work_description: "",
            observations: "",

            // TIPO DE TRABAJO
            work_type: "",

            // ESTADO DE LA MAQUINA
            machine_status: "",

            // CHECKLIST
            checklist: [],

            // NOVEDADES / PARADAS
            has_downtime: false,
            downtime_reason: "",
            downtime_hours: 0

        });

        setSelectedMachineryData(null);
        setEditingReport(null);

        setHorometerPhoto(null);
        setWorkPhoto(null);
        setExistingHorometerPhoto("");
        setExistingWorkPhoto("");

    };

    const getHeaderInfo = () => {
        if (viewMode === "day") {
            return {
                title: "📅 " + new Date(currentDate + "T00:00:00")
                    .toLocaleDateString("es-BO", {
                        weekday: "long",
                        day: "numeric",
                        month: "long",
                        year: "numeric"
                    }),
                subtitle: "Vista diaria"
            };
        }

        if (viewMode === "week") {
            const start = new Date(currentDate + "T00:00:00");
            start.setDate(start.getDate() - start.getDay());

            const end = new Date(start);
            end.setDate(end.getDate() + 6);

            return {
                title:
                    "🗓 Semana del " +
                    start.toLocaleDateString("es-BO") +
                    " al " +
                    end.toLocaleDateString("es-BO"),
                subtitle: "Vista semanal"
            };
        }

        if (viewMode === "month") {
            return {
                title:
                    "📅 " +
                    new Date(currentDate + "T00:00:00")
                        .toLocaleDateString("es-BO", {
                            month: "long",
                            year: "numeric"
                        }),
                subtitle: "Vista mensual"
            };
        }

        if (viewMode === "year") {
            return {
                title:
                    "🗂 " +
                    new Date(currentDate + "T00:00:00")
                        .getFullYear(),
                subtitle: "Vista anual"
            };
        }

        if (viewMode === "custom") {
            return {
                title: "📌 Período personalizado",
                subtitle:
                    fromDate && toDate
                        ? `${fromDate} al ${toDate}`
                        : "Seleccione un rango de fechas"
            };
        }

        return {
            title: "📋 Historial completo",
            subtitle: "Todos los partes"
        };
    };

    // Exportar resumen de Partes Diarios a PDF
    const exportPDF = () => {
        try {
            const doc = new jsPDF("landscape", "mm", "a4");

            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();

            const margin = 12;

            // =====================================================
            // PALETA PROFESIONAL
            // =====================================================

            const COLORS = {
                navy: [20, 42, 75],
                blue: [28, 115, 190],
                blueLight: [232, 242, 252],
                gray: [90, 100, 115],
                grayLight: [242, 244, 247],
                border: [210, 216, 224],
                white: [255, 255, 255],
                black: [25, 35, 50],
                diesel: [240, 166, 40],
                gasoline: [36, 117, 220],
                greenLight: [235, 247, 242],
                orangeLight: [255, 247, 232]
            };

            const fmt = (value, decimals = 2) => {
                const n = Number(value || 0);

                return n.toLocaleString("es-BO", {
                    minimumFractionDigits: decimals,
                    maximumFractionDigits: decimals
                });
            };

            const clean = (value) => {
                if (
                    value === null ||
                    value === undefined ||
                    value === ""
                ) {
                    return "-";
                }

                return String(value);
            };

            const getMachine = (report) =>
                machinery.find(
                    m => m.id === report.machinery_id
                ) || {};

            const getOperator = (report) =>
                operators.find(
                    o => o.id === report.operator_id
                ) ||
                users.find(
                    u => u.id === report.operator_id
                ) ||
                {};

            const getProjectName = (report) => {
                const project = projects.find(
                    p => p.id === report.project_id
                );

                return (
                    project?.name ||
                    report.project_id ||
                    "-"
                );
            };

            const getLocation = (report) =>
                report.location ||
                report.work_location ||
                "-";

            const getWorkType = (report) =>
                report.work_type || "-";

            const getMachineName = (report) => {
                const machine = getMachine(report);

                return (
                    machine.name ||
                    report.machinery_id ||
                    "-"
                );
            };

            const getOperatorName = (report) => {
                const op = getOperator(report);

                return (
                    op.name ||
                    op.full_name ||
                    op.username ||
                    report.operator_id ||
                    "-"
                );
            };

            const getHours = (report) => {
                if (
                    report.hours_worked !== undefined &&
                    report.hours_worked !== null
                ) {
                    return Number(
                        report.hours_worked || 0
                    );
                }

                const start = Number(
                    report.start_hours || 0
                );

                const end = Number(
                    report.end_hours || 0
                );

                return Math.max(
                    0,
                    end - start
                );
            };

            const getFuel = (report) =>
                Number(
                    report.diesel_consumed || 0
                );

            const normalizeFuelType = (value) => {
                if (!value) return null;

                const text = String(value)
                    .toLowerCase()
                    .normalize("NFD")
                    .replace(
                        /[\u0300-\u036f]/g,
                        ""
                    )
                    .trim();

                if (
                    text === "gasolina" ||
                    text === "gasoline" ||
                    text === "petrol" ||
                    text === "bencina" ||
                    text === "nafta" ||
                    text.includes("gasolina")
                ) {
                    return "gasolina";
                }

                if (
                    text === "diesel" ||
                    text === "gasoil" ||
                    text.includes("diesel") ||
                    text.includes("gasoil")
                ) {
                    return "diesel";
                }

                return null;
            };

            const getFuelType = (report) => {
                const machine = getMachine(report);

                const tank =
                    (
                        typeof availableFuelTanks !==
                        "undefined"
                    )
                        ? availableFuelTanks.find(
                              t =>
                                  t.id ===
                                  report.fuel_tank_id
                          )
                        : null;

                const candidates = [
                    tank?.fuel_type,
                    tank?.type,
                    machine?.fuel_type,
                    report?.fuel_type
                ];

                for (const candidate of candidates) {
                    const normalized =
                        normalizeFuelType(
                            candidate
                        );

                    if (normalized) {
                        return normalized;
                    }
                }

                return "sin_clasificar";
            };

            const isGasoline = report =>
                getFuelType(report) ===
                "gasolina";

            const isDiesel = report =>
                getFuelType(report) ===
                "diesel";

            const isVolqueta = report => {
                const machine =
                    getMachine(report);

                const name =
                    String(
                        machine.name || ""
                    ).toLowerCase();

                return /volqueta|volquete/.test(
                    name
                );
            };

            const reportDate = report => {
                if (!report.date) return "-";

                const raw = String(report.date);

                // Formato estable DD/MM/YYYY.
                // Evita que jsPDF divida fechas como 10/9/2026.
                const match = raw.match(
                    /^(\d{4})-(\d{1,2})-(\d{1,2})/
                );

                if (match) {
                    const year = match[1];
                    const month = match[2].padStart(2, "0");
                    const day = match[3].padStart(2, "0");

                    return `${day}/${month}/${year}`;
                }

                const d = new Date(
                    raw + "T00:00:00"
                );

                if (
                    Number.isNaN(
                        d.getTime()
                    )
                ) {
                    return raw;
                }

                const day = String(
                    d.getDate()
                ).padStart(2, "0");

                const month = String(
                    d.getMonth() + 1
                ).padStart(2, "0");

                const year = d.getFullYear();

                return `${day}/${month}/${year}`;
            };

            const allReports =
                [...filteredReports].sort(
                    (a, b) =>
                        String(a.date || "")
                            .localeCompare(
                                String(
                                    b.date || ""
                                )
                            )
                );

            const dieselReports =
                allReports.filter(
                    isDiesel
                );

            const gasolineReports =
                allReports.filter(
                    isGasoline
                );

            const dieselMachinery =
                dieselReports.filter(
                    r => !isVolqueta(r)
                );

            const dieselVolquetas =
                dieselReports.filter(
                    r => isVolqueta(r)
                );

            const gasolineMachinery =
                gasolineReports.filter(
                    r => !isVolqueta(r)
                );

            const gasolineVolquetas =
                gasolineReports.filter(
                    r => isVolqueta(r)
                );

            const sumHours = rows =>
                rows.reduce(
                    (sum, r) =>
                        sum + getHours(r),
                    0
                );

            const sumFuel = rows =>
                rows.reduce(
                    (sum, r) =>
                        sum + getFuel(r),
                    0
                );

            const totalHours =
                sumHours(allReports);

            const dieselFuel =
                sumFuel(dieselReports);

            const gasolineFuel =
                sumFuel(
                    gasolineReports
                );

            const totalFuel =
                dieselFuel +
                gasolineFuel;

            const uniqueMachines =
                new Set(
                    allReports
                        .map(
                            r =>
                                r.machinery_id
                        )
                        .filter(Boolean)
                ).size;

            const uniqueOperators =
                new Set(
                    allReports
                        .map(
                            r =>
                                r.operator_id
                        )
                        .filter(Boolean)
                ).size;

            const periodDates =
                allReports
                    .map(r => r.date)
                    .filter(Boolean)
                    .sort();

            const periodText =
                periodDates.length
                    ? `${reportDate({
                          date:
                              periodDates[0]
                      })} al ${reportDate({
                          date:
                              periodDates[
                                  periodDates.length -
                                      1
                              ]
                      })}`
                    : "Sin fecha";

            const generatedAt =
                new Date().toLocaleString(
                    "es-BO"
                );

            // =====================================================
            // ENCABEZADO
            // =====================================================

            const drawHeader = title => {
                doc.setFillColor(
                    ...COLORS.white
                );

                doc.rect(
                    0,
                    0,
                    pageWidth,
                    25,
                    "F"
                );

                doc.setFont(
                    "helvetica",
                    "bold"
                );

                doc.setFontSize(18);

                doc.setTextColor(
                    ...COLORS.navy
                );

                doc.text(
                    "MAQ",
                    margin,
                    11
                );

                const maqWidth =
                    doc.getTextWidth("MAQ");

                doc.setTextColor(
                    ...COLORS.blue
                );

                doc.text(
                    "CONTROL",
                    margin + maqWidth,
                    11
                );

                doc.setFontSize(8);

                doc.setTextColor(
                    ...COLORS.gray
                );

                doc.text(
                    "INFORME DE OPERACIONES",
                    margin,
                    17
                );

                doc.setFont(
                    "helvetica",
                    "bold"
                );

                doc.setFontSize(8);

                doc.setTextColor(
                    ...COLORS.navy
                );

                doc.text(
                    `Periodo: ${periodText}`,
                    pageWidth - margin,
                    9,
                    {
                        align: "right"
                    }
                );

                doc.setFont(
                    "helvetica",
                    "normal"
                );

                doc.setTextColor(
                    ...COLORS.gray
                );

                doc.text(
                    `Generado: ${generatedAt}`,
                    pageWidth - margin,
                    15,
                    {
                        align: "right"
                    }
                );

                doc.setDrawColor(
                    ...COLORS.blue
                );

                doc.setLineWidth(
                    0.7
                );

                doc.line(
                    margin,
                    22,
                    pageWidth - margin,
                    22
                );

                if (title) {
                    doc.setFont(
                        "helvetica",
                        "bold"
                    );

                    doc.setFontSize(11);

                    doc.setTextColor(
                        ...COLORS.navy
                    );

                    doc.text(
                        title,
                        margin,
                        31
                    );
                }
            };

            // =====================================================
            // BARRA DE SECCIÓN
            // =====================================================

            const sectionBar = (
                title,
                y,
                color = COLORS.navy
            ) => {
                doc.setFillColor(
                    ...color
                );

                doc.roundedRect(
                    margin,
                    y,
                    pageWidth -
                        margin * 2,
                    9,
                    2,
                    2,
                    "F"
                );

                doc.setFont(
                    "helvetica",
                    "bold"
                );

                doc.setFontSize(10);

                doc.setTextColor(
                    ...COLORS.white
                );

                doc.text(
                    title,
                    margin + 7,
                    y + 6.2
                );

                return y + 13;
            };

            // =====================================================
            // TARJETA KPI
            // =====================================================

            const kpiCard = (
                x,
                y,
                w,
                label,
                value,
                accent,
                background
            ) => {
                doc.setFillColor(
                    ...background
                );

                doc.setDrawColor(
                    ...COLORS.border
                );

                doc.roundedRect(
                    x,
                    y,
                    w,
                    25,
                    2.5,
                    2.5,
                    "FD"
                );

                doc.setFillColor(
                    ...accent
                );

                doc.roundedRect(
                    x,
                    y,
                    3,
                    25,
                    2,
                    2,
                    "F"
                );

                doc.setFont(
                    "helvetica",
                    "bold"
                );

                doc.setFontSize(7.5);

                doc.setTextColor(
                    ...COLORS.gray
                );

                doc.text(
                    label,
                    x + 8,
                    y + 8
                );

                doc.setFont(
                    "helvetica",
                    "bold"
                );

                doc.setFontSize(18);

                doc.setTextColor(
                    ...COLORS.navy
                );

                doc.text(
                    String(value),
                    x + 8,
                    y + 19
                );
            };

            // =====================================================
            // ESTILO TABLAS
            // =====================================================

            const tableStyles = {
                font: "helvetica",
                fontSize: 8,
                cellPadding: 3,
                lineColor:
                    COLORS.border,
                lineWidth: 0.25,
                textColor:
                    COLORS.black,
                valign: "middle"
            };

            const tableHeadStyles = {
                fillColor:
                    COLORS.navy,
                textColor:
                    COLORS.white,
                fontStyle:
                    "bold",
                fontSize: 8
            };

            const alternateRowStyles = {
                fillColor:
                    COLORS.grayLight
            };

            // =====================================================
            // FOOTER
            // =====================================================

            const addFooter = () => {
                const pages =
                    doc.getNumberOfPages();

                for (
                    let p = 1;
                    p <= pages;
                    p++
                ) {
                    doc.setPage(p);

                    doc.setDrawColor(
                        ...COLORS.border
                    );

                    doc.setLineWidth(
                        0.3
                    );

                    doc.line(
                        margin,
                        pageHeight - 11,
                        pageWidth -
                            margin,
                        pageHeight - 11
                    );

                    doc.setFont(
                        "helvetica",
                        "normal"
                    );

                    doc.setFontSize(7);

                    doc.setTextColor(
                        ...COLORS.gray
                    );

                    doc.text(
                        "MAQCONTROL — Informe de Partes Diarios",
                        margin,
                        pageHeight - 6
                    );

                    doc.text(
                        `Página ${p} de ${pages}`,
                        pageWidth -
                            margin,
                        pageHeight - 6,
                        {
                            align:
                                "right"
                        }
                    );
                }
            };

            // =====================================================
            // PÁGINA 1 — RESUMEN
            // =====================================================

            drawHeader(
                "RESUMEN GENERAL"
            );

            const cardGap = 5;
            const cardWidth =
                (pageWidth -
                    margin * 2 -
                    cardGap * 2) /
                3;

            kpiCard(
                margin,
                38,
                cardWidth,
                "PARTES",
                allReports.length,
                COLORS.blue,
                COLORS.blueLight
            );

            kpiCard(
                margin +
                    cardWidth +
                    cardGap,
                38,
                cardWidth,
                "EQUIPOS",
                uniqueMachines,
                COLORS.diesel,
                COLORS.orangeLight
            );

            kpiCard(
                margin +
                    (cardWidth +
                        cardGap) *
                        2,
                38,
                cardWidth,
                "OPERADORES",
                uniqueOperators,
                COLORS.blue,
                COLORS.greenLight
            );

            // -----------------------------------------------------
            // COMBUSTIBLE
            // -----------------------------------------------------

            let y = 70;

            y = sectionBar(
                "RESUMEN DE COMBUSTIBLE",
                y,
                COLORS.navy
            );

            autoTable(doc, {
                startY: y,
                margin: {
                    left: margin,
                    right: margin
                },
                theme: "grid",
                head: [[
                    "COMBUSTIBLE",
                    "PARTES",
                    "HORA/KILÓMETRO",
                    "CONSUMO (L)"
                ]],
                body: [
                    [
                        "DIÉSEL",
                        dieselReports.length,
                        fmt(
                            sumHours(
                                dieselReports
                            )
                        ),
                        fmt(
                            dieselFuel
                        )
                    ],
                    [
                        "GASOLINA",
                        gasolineReports.length,
                        fmt(
                            sumHours(
                                gasolineReports
                            )
                        ),
                        fmt(
                            gasolineFuel
                        )
                    ],
                    [
                        "TOTAL",
                        allReports.length,
                        fmt(
                            totalHours
                        ),
                        fmt(
                            totalFuel
                        )
                    ]
                ],
                styles:
                    tableStyles,
                headStyles:
                    tableHeadStyles,
                alternateRowStyles,
                didParseCell: data => {
                    if (
                        data.section ===
                            "body" &&
                        data.row.index ===
                            0
                    ) {
                        data.cell.styles.fillColor =
                            [
                                255,
                                249,
                                235
                            ];
                    }

                    if (
                        data.section ===
                            "body" &&
                        data.row.index ===
                            1
                    ) {
                        data.cell.styles.fillColor =
                            [
                                238,
                                246,
                                255
                            ];
                    }

                    if (
                        data.section ===
                            "body" &&
                        data.row.index ===
                            2
                    ) {
                        data.cell.styles.fillColor =
                            [
                                235,
                                239,
                                244
                            ];

                        data.cell.styles.fontStyle =
                            "bold";
                    }
                }
            });

            // -----------------------------------------------------
            // DISTRIBUCIÓN
            // SOLO MAQUINARIA
            // -----------------------------------------------------

            y =
                doc.lastAutoTable.finalY +
                9;

            y = sectionBar(
                "DISTRIBUCIÓN DE LA OPERACIÓN",
                y,
                COLORS.blue
            );

            autoTable(doc, {
                startY: y,
                margin: {
                    left: margin,
                    right: margin
                },
                theme: "grid",
                head: [[
                    "GRUPO",
                    "PARTES",
                    "HORA/KILÓMETRO",
                    "CONSUMO (L)"
                ]],
                body: [
                    [
                        "Maquinaria Diésel",
                        dieselMachinery.length,
                        fmt(
                            sumHours(
                                dieselMachinery
                            )
                        ),
                        fmt(
                            sumFuel(
                                dieselMachinery
                            )
                        )
                    ],
                    [
                        "Volquetas Diésel",
                        dieselVolquetas.length,
                        fmt(
                            sumHours(
                                dieselVolquetas
                            )
                        ),
                        fmt(
                            sumFuel(
                                dieselVolquetas
                            )
                        )
                    ],
                    [
                        "Maquinaria Gasolina",
                        gasolineMachinery.length,
                        fmt(
                            sumHours(
                                gasolineMachinery
                            )
                        ),
                        fmt(
                            sumFuel(
                                gasolineMachinery
                            )
                        )
                    ]
                ],
                styles:
                    tableStyles,
                headStyles: {
                    ...tableHeadStyles,
                    fillColor:
                        COLORS.blue
                },
                alternateRowStyles,
                didParseCell: data => {
                    if (
                        data.section ===
                            "body" &&
                        data.row.index ===
                            0
                    ) {
                        data.cell.styles.fillColor =
                            [
                                255,
                                249,
                                235
                            ];
                    }

                    if (
                        data.section ===
                            "body" &&
                        data.row.index ===
                            1
                    ) {
                        data.cell.styles.fillColor =
                            [
                                238,
                                246,
                                255
                            ];
                    }
                }
            });

            // =====================================================
            // DETALLE
            // =====================================================

            const addDetailSection = (
                title,
                rows
            ) => {
                if (!rows.length) {
                    return;
                }

                doc.addPage();

                const kilometers =
                    /VOLQUETAS/i.test(
                        title
                    );

                drawHeader(title);

                doc.setFont(
                    "helvetica",
                    "normal"
                );

                doc.setFontSize(8);

                doc.setTextColor(
                    ...COLORS.gray
                );

                doc.text(
                    `${rows.length} parte(s) | ` +
                    `${fmt(sumHours(rows))} ` +
                    `${kilometers ? "km" : "h"} | ` +
                    `${fmt(sumFuel(rows))} L`,
                    margin,
                    39
                );

                autoTable(doc, {
                    startY: 44,
                    margin: {
                        top: 39,
                        right: margin,
                        bottom: 13,
                        left: margin
                    },
                    theme: "grid",
                    head: [[
                        "FECHA",
                        "EQUIPO",
                        "OPERADOR",
                        "PROYECTO",
                        "ZONA / UBICACIÓN",
                        "TIPO TRABAJO",
                        kilometers
                            ? "KILÓMETROS"
                            : "HORAS",
                        "COMB. (L)"
                    ]],
                    body: rows.map(
                        r => [
                            reportDate(r),
                            getMachineName(
                                r
                            ),
                            getOperatorName(
                                r
                            ),
                            getProjectName(
                                r
                            ),
                            clean(
                                getLocation(
                                    r
                                )
                            ),
                            clean(
                                getWorkType(
                                    r
                                )
                            ),
                            fmt(
                                getHours(
                                    r
                                )
                            ),
                            getFuel(r) >
                            0
                                ? fmt(
                                      getFuel(
                                          r
                                      )
                                  )
                                : "-"
                        ]
                    ),
                    styles:
                        tableStyles,
                    headStyles:
                        tableHeadStyles,
                    alternateRowStyles,
                    columnStyles: {
                        // Fecha ampliada para mantener
                        // DD/MM/YYYY en una sola línea.
                        0: {
                            cellWidth: 25,
                            halign: "center"
                        },

                        1: {
                            cellWidth: 29
                        },

                        2: {
                            cellWidth: 28
                        },

                        3: {
                            cellWidth: 29
                        },

                        4: {
                            cellWidth: 43
                        },

                        5: {
                            cellWidth: 30
                        },

                        6: {
                            cellWidth: 20,
                            halign:
                                "right"
                        },

                        7: {
                            cellWidth: 22,
                            halign:
                                "right"
                        }
                    },
                    didDrawPage: () => {
                        drawHeader(
                            title
                        );
                    }
                });
            };

            // DIÉSEL

            addDetailSection(
                "MAQUINARIA DIÉSEL — DETALLE",
                dieselMachinery
            );

            addDetailSection(
                "VOLQUETAS DIÉSEL — DETALLE",
                dieselVolquetas
            );

            // GASOLINA

            addDetailSection(
                "MAQUINARIA GASOLINA — DETALLE",
                gasolineMachinery
            );

            // Solo generar volquetas gasolina
            // si realmente existen.
            addDetailSection(
                "VOLQUETAS GASOLINA — DETALLE",
                gasolineVolquetas
            );

            // =====================================================
            // RESUMEN POR EQUIPO
            // =====================================================

            const machineMap = {};

            allReports.forEach(
                r => {
                    const id =
                        r.machinery_id ||
                        "SIN_ID";

                    if (!machineMap[id]) {
                        machineMap[id] = {
                            name:
                                getMachineName(
                                    r
                                ),
                            fuelType:
                                getFuelType(
                                    r
                                ),
                            category:
                                isVolqueta(
                                    r
                                )
                                    ? "Volqueta"
                                    : "Maquinaria",
                            reports: 0,
                            hours: 0,
                            fuel: 0
                        };
                    }

                    machineMap[
                        id
                    ].reports += 1;

                    machineMap[
                        id
                    ].hours +=
                        getHours(r);

                    machineMap[
                        id
                    ].fuel +=
                        getFuel(r);
                }
            );

            const machineRows =
                Object.values(
                    machineMap
                )
                    .sort((a, b) =>
                        a.name.localeCompare(
                            b.name
                        )
                    )
                    .map(
                        m => [
                            m.name,
                            m.fuelType ===
                            "gasolina"
                                ? "Gasolina"
                                : m.fuelType ===
                                  "diesel"
                                ? "Diésel"
                                : "Sin clasificar",
                            m.category,
                            m.reports,
                            fmt(m.hours),
                            fmt(m.fuel)
                        ]
                    );

            if (
                machineRows.length
            ) {
                doc.addPage();

                drawHeader(
                    "RESUMEN POR EQUIPO"
                );

                autoTable(doc, {
                    startY: 39,
                    margin: {
                        left: margin,
                        right: margin
                    },
                    theme: "grid",
                    head: [[
                        "EQUIPO",
                        "COMBUSTIBLE",
                        "CATEGORÍA",
                        "PARTES",
                        "HORAS/KILÓMETROS",
                        "CONSUMO (L)"
                    ]],
                    body:
                        machineRows,
                    styles:
                        tableStyles,
                    headStyles:
                        tableHeadStyles,
                    alternateRowStyles,
                    columnStyles: {
                        0: {
                            cellWidth: 52
                        },
                        1: {
                            cellWidth: 32
                        },
                        2: {
                            cellWidth: 38
                        },
                        3: {
                            cellWidth: 20,
                            halign:
                                "right"
                        },
                        4: {
                            cellWidth: 38,
                            halign:
                                "right"
                        },
                        5: {
                            cellWidth: 32,
                            halign:
                                "right"
                        }
                    }
                });
            }

            // =====================================================
            // FOOTER
            // =====================================================

            addFooter();

            const filename =
                `MaqControl_Informe_Operaciones_${new Date()
                    .toISOString()
                    .slice(0, 10)}.pdf`;

            doc.save(filename);

            console.log(
                "PDF V4 generado:",
                filename
            );

        } catch (error) {
            console.error(
                "Error generando PDF:",
                error
            );

            alert(
                "No se pudo generar el PDF: " +
                (
                    error?.message ||
                    error
                )
            );
        }
    };;;;

    const exportDailyReportPDF = async (report) => {
        try {
            if (!report) {
                toast.error("No hay un Parte Diario seleccionado");
                return;
            }

            const doc = new jsPDF({
                orientation: "portrait",
                unit: "mm",
                format: "a4"
            });

            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();

            const colors = {
                dark: [31, 50, 68],
                orange: [234, 101, 22],
                gray: [100, 116, 139],
                light: [241, 245, 249],
                border: [203, 213, 225],
                green: [22, 163, 74],
                yellow: [245, 158, 11]
            };

            const margin = 10;
            const contentWidth = pageWidth - margin * 2;

            const machineName = getMachineryName(report.machinery_id) || "-";
            const operatorName = getOperatorName(report.operator_id) || "-";
            const projectName = getProjectName(report.project_id) || "-";

            const status =
                report.machine_status === "operativa"
                    ? "Operativa"
                    : report.machine_status === "operativa_con_observaciones"
                    ? "Operativa con observaciones"
                    : report.machine_status === "fuera_de_servicio"
                    ? "Fuera de servicio"
                    : "-";

            const hours = Number(report.hours_worked || 0);
            const diesel = Number(report.diesel_consumed || 0);
            const consumption = hours > 0 ? diesel / hours : 0;

            const formatNumber = (value, decimals = 2) =>
                Number(value || 0).toFixed(decimals);

            const drawSection = (title, y, width = contentWidth, color = colors.dark) => {
                doc.setFillColor(...color);
                doc.roundedRect(margin, y, width, 7, 1.5, 1.5, "F");

                doc.setTextColor(255, 255, 255);
                doc.setFont("helvetica", "bold");
                doc.setFontSize(8.5);
                doc.text(title.toUpperCase(), margin + 3, y + 4.8);

                return y + 10;
            };

            const drawField = (label, value, x, y, width) => {
                doc.setTextColor(...colors.gray);
                doc.setFont("helvetica", "normal");
                doc.setFontSize(6.5);
                doc.text(label, x, y);

                doc.setTextColor(...colors.dark);
                doc.setFont("helvetica", "bold");
                doc.setFontSize(8);
                const lines = doc.splitTextToSize(String(value || "-"), width);
                doc.text(lines.slice(0, 2), x, y + 4);
            };

            const loadImage = async (src) => {
                if (!src) return null;

                try {
                    const url = src.startsWith("/uploads/")
                        ? `${API.replace("/api", "")}${src}`
                        : src;

                    const response = await fetch(url);
                    if (!response.ok) return null;

                    const blob = await response.blob();

                    return await new Promise((resolve, reject) => {
                        const reader = new FileReader();

                        reader.onload = () => resolve(reader.result);
                        reader.onerror = reject;

                        reader.readAsDataURL(blob);
                    });
                } catch (error) {
                    console.error("Error cargando imagen PDF:", error);
                    return null;
                }
            };

            // ENCABEZADO
            doc.setFillColor(...colors.dark);
            doc.rect(0, 0, pageWidth, 25, "F");

            doc.setTextColor(255, 255, 255);
            doc.setFont("helvetica", "bold");
            doc.setFontSize(20);
            doc.text("MAQ", margin, 10);

            doc.setTextColor(...colors.orange);
            doc.text("CONTROL", margin + 16, 10);

            doc.setTextColor(220, 228, 236);
            doc.setFont("helvetica", "normal");
            doc.setFontSize(6.5);
            doc.text("GESTIÓN DE OPERACIONES Y MAQUINARIA", margin, 16);

            doc.setTextColor(255, 255, 255);
            doc.setFont("helvetica", "bold");
            doc.setFontSize(12);
            doc.text("PARTE DIARIO DE MAQUINARIA", pageWidth - margin, 9, {
                align: "right"
            });

            doc.setFont("helvetica", "normal");
            doc.setFontSize(7);
            doc.text("REGISTRO DE OPERACIÓN Y ACTIVIDADES", pageWidth - margin, 15, {
                align: "right"
            });

            let y = 30;

            // INFORMACION GENERAL
            y = drawSection("1. Información General", y);

            doc.setFillColor(248, 250, 252);
            doc.setDrawColor(...colors.border);
            doc.roundedRect(margin, y - 3, contentWidth, 22, 2, 2, "FD");

            const col1 = margin + 4;
            const col2 = margin + 67;
            const col3 = margin + 134;

            drawField("Fecha", report.date || "-", col1, y + 3, 55);
            drawField("Maquinaria", machineName, col2, y + 3, 60);
            drawField("Operador", operatorName, col3, y + 3, 55);

            drawField("Proyecto", projectName, col1, y + 12, 55);
            drawField("Tipo de trabajo", report.work_type || "-", col2, y + 12, 60);
            drawField("Ubicación", report.location || "-", col3, y + 12, 55);

            y += 23;

            // HOROMETRO + COMBUSTIBLE
            const half = (contentWidth - 4) / 2;

            doc.setFillColor(255, 247, 237);
            doc.setDrawColor(...colors.orange);
            doc.roundedRect(margin, y, half, 29, 2, 2, "FD");

            doc.setFillColor(...colors.orange);
            doc.roundedRect(margin, y, half, 7, 1.5, 1.5, "F");

            doc.setTextColor(255, 255, 255);
            doc.setFont("helvetica", "bold");
            doc.setFontSize(8);
            doc.text("2. HORÓMETRO", margin + 3, y + 4.8);

            const hx = margin + 5;
            const hw = (half - 10) / 3;

            drawField("Inicial", `${formatNumber(report.start_hours, 1)} h`, hx, y + 13, hw);
            drawField("Final", `${formatNumber(report.end_hours, 1)} h`, hx + hw, y + 13, hw);
            drawField("Horas trabajadas", `${formatNumber(hours, 1)} h`, hx + hw * 2, y + 13, hw);

            doc.setTextColor(...colors.orange);
            doc.setFont("helvetica", "bold");
            doc.setFontSize(10);
            doc.text(`${formatNumber(hours, 1)} h`, hx + hw * 2, y + 21);

            const fuelX = margin + half + 4;

            doc.setFillColor(248, 250, 252);
            doc.setDrawColor(...colors.border);
            doc.roundedRect(fuelX, y, half, 29, 2, 2, "FD");

            doc.setFillColor(...colors.dark);
            doc.roundedRect(fuelX, y, half, 7, 1.5, 1.5, "F");

            doc.setTextColor(255, 255, 255);
            doc.setFont("helvetica", "bold");
            doc.setFontSize(8);
            doc.text("3. COMBUSTIBLE Y FLUIDOS", fuelX + 3, y + 4.8);

            const fluids = [
                ["Diésel", `${formatNumber(diesel)} L`],
                ["Aceite motor", `${formatNumber(report.engine_oil_consumed)} L`],
                ["Aceite transmisión", `${formatNumber(report.transmission_oil_consumed)} L`],
                ["Aceite diferencial", `${formatNumber(report.differential_oil_consumed)} L`],
                ["Aceite hidráulico", `${formatNumber(report.hydraulic_oil_consumed)} L`],
                ["Refrigerante", `${formatNumber(report.coolant_consumed)} L`],
                ["Grasa", `${formatNumber(report.grease_consumed)} kg`],
                ["Otro fluido", formatNumber(report.other_fluid_consumed)]
            ];

            const fw = (half - 8) / 4;

            fluids.forEach((item, index) => {
                const row = Math.floor(index / 4);
                const col = index % 4;
                drawField(
                    item[0],
                    item[1],
                    fuelX + 3 + col * fw,
                    y + 12 + row * 9,
                    fw - 2
                );
            });

            y += 34;

            // OPERACION / ESTADO / CHECKLIST
            const operationWidth = 77;
            const statusWidth = 43;
            const checklistWidth = contentWidth - operationWidth - statusWidth - 8;

            y = drawSection("4. Operación", y, operationWidth);
            const opY = y - 3;

            doc.setFillColor(255, 255, 255);
            doc.setDrawColor(...colors.border);
            doc.roundedRect(margin, opY, operationWidth, 40, 2, 2, "FD");

            doc.setTextColor(...colors.gray);
            doc.setFont("helvetica", "normal");
            doc.setFontSize(6.5);
            doc.text("Descripción del trabajo", margin + 4, opY + 7);

            doc.setTextColor(...colors.dark);
            doc.setFont("helvetica", "normal");
            doc.setFontSize(7.5);

            const description = doc.splitTextToSize(
                report.work_description || "-",
                operationWidth - 8
            );

            doc.text(description.slice(0, 5), margin + 4, opY + 13);

            const statusX = margin + operationWidth + 4;

            doc.setFillColor(255, 255, 255);
            doc.setDrawColor(...colors.border);
            doc.roundedRect(statusX, opY, statusWidth, 40, 2, 2, "FD");

            doc.setFillColor(...colors.dark);
            doc.roundedRect(statusX, opY, statusWidth, 7, 1.5, 1.5, "F");

            doc.setTextColor(255, 255, 255);
            doc.setFont("helvetica", "bold");
            doc.setFontSize(7.5);
            doc.text("5. ESTADO", statusX + 3, opY + 4.8);

            doc.setTextColor(
                ...(status === "Operativa" ? colors.green : colors.yellow)
            );
            doc.setFont("helvetica", "bold");
            doc.setFontSize(9);
            doc.text(status, statusX + 4, opY + 17);

            const checklistX = statusX + statusWidth + 4;

            doc.setFillColor(255, 255, 255);
            doc.setDrawColor(...colors.border);
            doc.roundedRect(checklistX, opY, checklistWidth, 40, 2, 2, "FD");

            doc.setFillColor(...colors.dark);
            doc.roundedRect(checklistX, opY, checklistWidth, 7, 1.5, 1.5, "F");

            doc.setTextColor(255, 255, 255);
            doc.setFont("helvetica", "bold");
            doc.setFontSize(7.5);
            doc.text("6. CHECKLIST", checklistX + 3, opY + 4.8);

            const checklist = Array.isArray(report.checklist)
                ? report.checklist
                : [];

            doc.setTextColor(...colors.dark);
            doc.setFont("helvetica", "normal");
            doc.setFontSize(6.8);

            checklist.slice(0, 12).forEach((item, index) => {
                const row = index % 6;
                const col = Math.floor(index / 6);
                const x = checklistX + 4 + col * (checklistWidth / 2);
                const yy = opY + 13 + row * 4.5;

                doc.setTextColor(...colors.green);
                doc.setFont("helvetica", "bold");
                doc.text("✓", x, yy);

                doc.setTextColor(...colors.dark);
                doc.setFont("helvetica", "normal");
                doc.text(String(item), x + 4, yy);
            });

            y = opY + 45;

            // FOTOGRAFIAS
            if (report.horometer_photo || report.work_photo) {
                y = drawSection("7. Fotografías de Evidencia", y, contentWidth, colors.orange);

                const photoY = y - 3;
                const photoGap = 5;
                const photoWidth = (contentWidth - photoGap) / 2;
                const photoHeight = 67;

                const horometerImage = await loadImage(report.horometer_photo);
                const workImage = await loadImage(report.work_photo);

                const drawPhoto = (image, title, x) => {
                    doc.setFillColor(255, 255, 255);
                    doc.setDrawColor(...colors.border);
                    doc.roundedRect(x, photoY, photoWidth, photoHeight, 2, 2, "FD");

                    doc.setTextColor(...colors.dark);
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(7);
                    doc.text(title, x + 3, photoY + 6);

                    if (!image) {
                        doc.setTextColor(...colors.gray);
                        doc.setFont("helvetica", "normal");
                        doc.setFontSize(7);
                        doc.text("Imagen no disponible", x + photoWidth / 2, photoY + 35, {
                            align: "center"
                        });
                        return;
                    }

                    try {
                        const props = doc.getImageProperties(image);
                        const maxW = photoWidth - 6;
                        const maxH = photoHeight - 11;

                        let imgW = maxW;
                        let imgH = imgW * props.height / props.width;

                        if (imgH > maxH) {
                            imgH = maxH;
                            imgW = imgH * props.width / props.height;
                        }

                        doc.addImage(
                            image,
                            "JPEG",
                            x + (photoWidth - imgW) / 2,
                            photoY + 8,
                            imgW,
                            imgH
                        );
                    } catch (error) {
                        console.error("Error insertando imagen PDF:", error);
                    }
                };

                drawPhoto(horometerImage, "Horómetro", margin);
                drawPhoto(workImage, "Trabajo realizado", margin + photoWidth + photoGap);

                y = photoY + photoHeight + 5;
            }

            // OBSERVACIONES
            if (report.observations) {
                y = drawSection("8. Observaciones", y);

                doc.setFillColor(255, 251, 235);
                doc.setDrawColor(253, 230, 138);
                doc.roundedRect(margin, y - 3, contentWidth, 18, 2, 2, "FD");

                doc.setTextColor(...colors.dark);
                doc.setFont("helvetica", "normal");
                doc.setFontSize(7);

                const obs = doc.splitTextToSize(
                    report.observations,
                    contentWidth - 8
                );

                doc.text(obs.slice(0, 3), margin + 4, y + 4);
                y += 22;
            }

            // CONTROL DE CONSUMO
            doc.setFillColor(248, 250, 252);
            doc.setDrawColor(...colors.border);
            doc.roundedRect(margin, y, contentWidth, 16, 2, 2, "FD");

            doc.setTextColor(...colors.dark);
            doc.setFont("helvetica", "bold");
            doc.setFontSize(7);
            doc.text("CONTROL DE CONSUMO", margin + 4, y + 5);

            doc.setFont("helvetica", "normal");
            doc.setFontSize(7);
            doc.text(
                `Diésel: ${formatNumber(diesel)} L`,
                margin + 4,
                y + 11
            );

            doc.text(
                `Horas: ${formatNumber(hours, 1)} h`,
                margin + 60,
                y + 11
            );

            doc.setFont("helvetica", "bold");
            doc.setTextColor(...colors.orange);
            doc.text(
                `Consumo promedio: ${formatNumber(consumption)} L/h`,
                margin + 120,
                y + 11
            );

            // FIRMAS
            const signatureY = pageHeight - 24;

            doc.setDrawColor(...colors.gray);
            doc.line(margin + 10, signatureY, margin + 75, signatureY);
            doc.line(pageWidth - margin - 75, signatureY, pageWidth - margin - 10, signatureY);

            doc.setTextColor(...colors.gray);
            doc.setFont("helvetica", "normal");
            doc.setFontSize(6.5);

            doc.text("Firma del Operador", margin + 42.5, signatureY + 4, {
                align: "center"
            });

            doc.text(
                "Firma de Supervisión",
                pageWidth - margin - 42.5,
                signatureY + 4,
                { align: "center" }
            );

            // PIE
            doc.setDrawColor(...colors.border);
            doc.line(margin, pageHeight - 14, pageWidth - margin, pageHeight - 14);

            doc.setTextColor(...colors.dark);
            doc.setFont("helvetica", "bold");
            doc.setFontSize(7);
            doc.text("MAQCONTROL", margin, pageHeight - 9);

            doc.setTextColor(...colors.gray);
            doc.setFont("helvetica", "normal");
            doc.setFontSize(6);
            doc.text(
                "GESTIÓN DE OPERACIONES Y MAQUINARIA",
                margin,
                pageHeight - 5
            );

            doc.text(
                `Generado: ${new Date().toLocaleString("es-BO")}`,
                pageWidth - margin,
                pageHeight - 7,
                { align: "right" }
            );

            const pdfBlob = doc.output("blob");
            const pdfURL = URL.createObjectURL(pdfBlob);

            window.open(pdfURL, "_blank");

            setTimeout(() => {
                URL.revokeObjectURL(pdfURL);
            }, 60000);

            toast.success("PDF del Parte Diario generado");
        } catch (error) {
            console.error("Error generando PDF del Parte Diario:", error);
            toast.error("No se pudo generar el PDF del Parte Diario");
        }
    };

    //Exportar a Excel
    const exportExcel = () => {

    const summary = {

        totalReports: filteredReports.length,

        totalHours: filteredReports.reduce(

            (sum, report) =>

                sum + Number(report.hours_worked || 0),

            0

        ),

        totalFuel: filteredReports.reduce(

            (sum, report) =>

                sum + Number(report.diesel_consumed || 0),

            0

        ),

        totalMachines: new Set(

            filteredReports.map(

                report => report.machinery_id

            )

        ).size,

        totalOperators: new Set(

            filteredReports.map(

                report => report.operator_id

            )

        ).size

    };

    const header = getHeaderInfo();

    exportDailyReportsExcel(

        filteredReports,

        summary,

        header.title,

        user?.name || "Administrador"

    );

};


const filteredReports = useMemo(() => {

    let data = [...reports];

    if (search) {
        const term = search.toLowerCase();

        data = data.filter(report => {

            const machine = getMachineryName(report.machinery_id).toLowerCase();
            const operator = getOperatorName(report.operator_id).toLowerCase();

            return (
                machine.includes(term) ||
                operator.includes(term) ||
                (report.location || "").toLowerCase().includes(term) ||
                (report.work_description || "").toLowerCase().includes(term)
            );

        });
    }

    if (selectedMachine) {
        data = data.filter(
            report => String(report.machinery_id) === String(selectedMachine)
        );
    }

    if (selectedOperator) {
        data = data.filter(
            report => String(report.operator_id) === String(selectedOperator)
        );
    }

    if (viewMode === "day") {

        data = data.filter(
            report => report.date === currentDate
        );

    } else if (viewMode === "week") {

        const current = new Date(currentDate + "T00:00:00");

        const start = new Date(current);
        start.setDate(current.getDate() - current.getDay());

        const end = new Date(start);
        end.setDate(start.getDate() + 6);

        data = data.filter(report => {

            const d = new Date(report.date + "T00:00:00");

            return d >= start && d <= end;

        });

    } else if (viewMode === "month") {

        const current = new Date(currentDate + "T00:00:00");

        data = data.filter(report => {

            const d = new Date(report.date + "T00:00:00");

            return (
                d.getMonth() === current.getMonth() &&
                d.getFullYear() === current.getFullYear()
            );

        });

    } else if (viewMode === "year") {

        const year = new Date(currentDate + "T00:00:00").getFullYear();

        data = data.filter(report =>
            new Date(report.date + "T00:00:00").getFullYear() === year
        );

    } else if (viewMode === "custom") {

        if (fromDate) {
            data = data.filter(report => report.date >= fromDate);
        }

        if (toDate) {
            data = data.filter(report => report.date <= toDate);
        }

    }

    switch (sortBy) {

        case "date_asc":
            data.sort((a, b) => a.date.localeCompare(b.date));
            break;

        case "date_desc":
            data.sort((a, b) => b.date.localeCompare(a.date));
            break;

        default:
            break;
    }

    return data;

}, [
    reports,
    search,
    selectedMachine,
    selectedOperator,
    selectedDate,
    sortBy,
    viewMode,
    currentDate,
    fromDate,
    toDate
]);

const getMachineryName = (id) => {
    const machine = machinery.find(m => String(m.id) === String(id));
    return machine ? machine.name : "Sin maquinaria";
};

const getOperatorName = (id) => {
    const operator = users.find(u => String(u.id) === String(id));
    return operator ? operator.name : "Sin operador";
};

const getProjectName = (id) => {
    const project = projects.find(p => String(p.id) === String(id));
    return project ? project.name : "Sin proyecto";
};

const formatDateTime = (value) => {
    if (!value) return "-";

    return new Date(value).toLocaleString("es-BO", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    });
};

    const groupedReports = filteredReports.reduce((groups, report) => {
    const date = report.date;

    if (!groups[date]) {
        groups[date] = [];
    }

    groups[date].push(report);

    return groups;
}, {});

    const stats = {
        reports: reports.length,
        hours: reports.reduce(
            (t, r) => t + Number(r.hours_worked || 0),
            0
        ),
        diesel: reports.reduce(
            (t, r) => t + Number(r.diesel_consumed || 0),
            0
        ),
        machines: new Set(
            reports.map(r => r.machinery_id)
        ).size,
        operators: new Set(
            reports.map(r => r.operator_id)
        ).size
    };

    const header = getHeaderInfo();
    return (

<div className="space-y-6" data-testid="daily-reports-page">

    {/* ================= HEADER ================= */}

    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-5">

        <div>

            <div className="flex items-center gap-3">

                <div className="w-14 h-14 rounded-2xl bg-orange-100 flex items-center justify-center">

                    <ClipboardList className="text-orange-600" size={30}/>

                </div>

                <div>

                    <h1 className="text-4xl font-black text-slate-800">

                        Partes Diarios

                    </h1>

                    <p className="text-slate-500">

                        Control diario de maquinaria pesada

                    </p>

                </div>

            </div>

        </div>

        <Dialog
            open={dialogOpen}
            onOpenChange={(open)=>{

                setDialogOpen(open);

                if(!open) resetForm();

            }}
        >

            <DialogTrigger asChild>

                <Button
                    className="h-12 px-6 rounded-xl bg-orange-600 hover:bg-orange-700"
                >

                    <Plus size={18}/>

                    Nuevo Parte

                </Button>

            </DialogTrigger>

            <DialogContent className="max-w-3xl max-h-[92vh] overflow-y-auto">

                <DialogHeader>

                    <DialogTitle>

                        {

                            editingReport

                            ?

                            "Editar Parte Diario"

                            :

                            "Nuevo Parte Diario"

                        }

                    </DialogTitle>

                </DialogHeader>

                <form
                    onSubmit={handleSubmit}
                    className="space-y-5"
                >

                    <div className="grid lg:grid-cols-2 gap-4">

                        <div>

                            <label>Maquinaria</label>

                            <select

                                value={formData.machinery_id}

                                onChange={(e) => {
    const machineryId = e.target.value;

    const machine = machinery.find(
        m => String(m.id) === String(machineryId)
    );
console.log("Maquinaria:", machine);

console.log("Tanques:", fuelTanks);

console.log("Tipo de combustible:", machine?.fuel_type);
    const compatibleTanks = fuelTanks.filter(
        tank =>
            tank.fuel_type === machine?.fuel_type &&
            tank.current_stock > 0
    );
console.log("Tanques compatibles:", compatibleTanks);
    setSelectedMachineryData(machine || null);

    const machineEngineHours = Number(
        machine?.engine_hours || 0
    );

    setFormData(prev => ({
        ...prev,
        machinery_id: machineryId,

        // HORÓMETRO AUTOMÁTICO
        start_hours: machineEngineHours,
        end_hours: 0,
        hours_worked: 0,

        // TANQUE COMPATIBLE
        fuel_tank_id:
            compatibleTanks.length > 0
                ? compatibleTanks[0].id
                : ""
    }));
    setDialogOpen(true);
}}

                                className="input-field"

                                required

                            >

                                <option value="">

                                    Seleccione...

                                </option>

                                {

                                    machinery.map(machine=>(

                                        <option

                                            key={machine.id}

                                            value={machine.id}

                                        >

                                            {machine.name}

                                        </option>

                                    ))

                                }

                            </select>

                        </div>

                        <div>

                            <label>Operador</label>

                            <input

                                value={user.name}

                                disabled

                                className="input-field bg-slate-100"

                            />

                        </div>

                    </div>

                    <div>

                        <label>Proyecto</label>

                        <select

                            value={formData.project_id}

                            onChange={(e)=>

                                setFormData({

                                    ...formData,

                                    project_id:e.target.value

                                })

                            }

                            className="input-field"

                        >

                            <option value="">

                                Seleccione...

                            </option>

                            {

                                projects.map(project=>(

                                    <option

                                        key={project.id}

                                        value={project.id}

                                    >

                                        {project.name}

                                    </option>

                                ))

                            }

                        </select>

                    </div>

                    <div className="grid lg:grid-cols-4 gap-4">

                        <div>

                            <label>Fecha</label>

                            <input

                                type="date"

                                value={formData.date}

                                className="input-field"

                                onChange={(e) =>

                                    setFormData({

                                        ...formData,

                                        date: e.target.value

                                    })

                                }

                            />

                        </div>

                        <div>

                            <label>Horómetro Inicial</label>

                            <input

                                type="number"

                                step="0.1"

                                className="input-field bg-slate-100"

                                value={formData.start_hours}

                                readOnly

                            />

                            <p className="text-xs text-slate-500 mt-1">

                                Tomado automáticamente de la maquinaria

                            </p>

                        </div>

                        <div>

                            <label>Horómetro Final</label>

                            <input

                                type="number"

                                step="0.1"

                                min={Number(formData.start_hours || 0) + 0.1}

                                className="input-field"

                                value={formData.end_hours}

                                onChange={(e) => {

                                    const finalHours = Number(e.target.value || 0);

                                    const initialHours = Number(formData.start_hours || 0);

                                    const workedHours = Math.max(

                                        Number((finalHours - initialHours).toFixed(1)),

                                        0

                                    );

                                    setFormData({

                                        ...formData,

                                        end_hours: finalHours,

                                        hours_worked: workedHours

                                    });

                                }}

                                required

                            />

                        </div>

                        <div>

                            <label>Horas Trabajadas</label>

                            <input

                                type="number"

                                step="0.1"

                                className="input-field bg-slate-100"

                                value={Number(formData.hours_worked || 0).toFixed(1)}

                                readOnly

                            />

                            <p className="text-xs text-slate-500 mt-1">

                                Final − Inicial

                            </p>

                        </div>

                    </div>

                    <div className="grid lg:grid-cols-2 gap-4">

                        <div>

                            <label>
    {selectedMachineryData
        ? `Carga de Combustible (${selectedMachineryData.fuel_type === "diesel"
            ? "Diésel"
            : "Gasolina"})`
        : "Carga de Combustible"}
</label>

                            <input

                                type="number"

                                step="0.1"

                                className="input-field"

                                value={formData.diesel_consumed}

                                onChange={(e)=>

                                    setFormData({

                                        ...formData,

                                        diesel_consumed:Number(e.target.value)

                                    })

                                }

                            />

                        </div>

                        <div className="lg:col-span-2">

                            <label className="block mb-3 font-medium">
                                Lubricantes y Fluidos
                            </label>

                            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">

                                <div>
                                    <label>Aceite de motor (L)</label>
                                    <input
                                        type="number"
                                        min="0"
                                        step="0.1"
                                        className="input-field"
                                        value={formData.engine_oil_consumed}
                                        onChange={(e) => {
                                            const value = Number(e.target.value || 0);
                                            setFormData({
                                                ...formData,
                                                engine_oil_consumed: value,
                                                oil_consumed: value
                                            });
                                        }}
                                    />
                                </div>

                                <div>
                                    <label>Aceite de transmisión (L)</label>
                                    <input
                                        type="number"
                                        min="0"
                                        step="0.1"
                                        className="input-field"
                                        value={formData.transmission_oil_consumed}
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                transmission_oil_consumed: Number(e.target.value || 0)
                                            })
                                        }
                                    />
                                </div>

                                <div>
                                    <label>Aceite diferencial (L)</label>
                                    <input
                                        type="number"
                                        min="0"
                                        step="0.1"
                                        className="input-field"
                                        value={formData.differential_oil_consumed}
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                differential_oil_consumed: Number(e.target.value || 0)
                                            })
                                        }
                                    />
                                </div>

                                <div>
                                    <label>Aceite hidráulico (L)</label>
                                    <input
                                        type="number"
                                        min="0"
                                        step="0.1"
                                        className="input-field"
                                        value={formData.hydraulic_oil_consumed}
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                hydraulic_oil_consumed: Number(e.target.value || 0)
                                            })
                                        }
                                    />
                                </div>

                                <div>
                                    <label>Refrigerante (L)</label>
                                    <input
                                        type="number"
                                        min="0"
                                        step="0.1"
                                        className="input-field"
                                        value={formData.coolant_consumed}
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                coolant_consumed: Number(e.target.value || 0)
                                            })
                                        }
                                    />
                                </div>

                                <div>
                                    <label>Grasa (kg)</label>
                                    <input
                                        type="number"
                                        min="0"
                                        step="0.1"
                                        className="input-field"
                                        value={formData.grease_consumed}
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                grease_consumed: Number(e.target.value || 0)
                                            })
                                        }
                                    />
                                </div>

                                <div>
                                    <label>Otro fluido</label>
                                    <input
                                        type="number"
                                        min="0"
                                        step="0.1"
                                        className="input-field"
                                        value={formData.other_fluid_consumed}
                                        onChange={(e) =>
                                            setFormData({
                                                ...formData,
                                                other_fluid_consumed: Number(e.target.value || 0)
                                            })
                                        }
                                    />
                                </div>

                            </div>

                        </div>

                    </div>

                    {

                        formData.diesel_consumed>0 && (

                            <div className="bg-orange-50 rounded-xl border border-orange-200 p-5">

                                <div className="flex items-center gap-2 mb-3">

                                    <Fuel size={18}/>

                                    Tanque de Combustible

                                </div>

                                {availableFuelTanks.length === 0 ? (
    <div className="rounded-lg bg-red-50 border border-red-200 p-3 text-sm text-red-700">
        No existe un tanque disponible para este tipo de combustible.
    </div>
) : availableFuelTanks.length > 1 ? (
    <select
        value={formData.fuel_tank_id}
        className="input-field"
        onChange={(e) =>
            setFormData({
                ...formData,
                fuel_tank_id: e.target.value
            })
        }
    >
        <option value="">Seleccione un tanque...</option>

        {availableFuelTanks.map(tank => (
            <option key={tank.id} value={tank.id}>
                {tank.name} - {tank.current_stock.toFixed(1)} L
            </option>
        ))}
    </select>
) : (
    <div className="rounded-lg bg-green-50 border border-green-200 p-3 text-sm">
        Tanque seleccionado automáticamente:
        <strong> {availableFuelTanks[0].name}</strong>
    </div>
)}

                            </div>

                        )

                    }

                    <div className="grid lg:grid-cols-2 gap-4">

                        <div>

                            <label>Tipo de Trabajo</label>

                            <select
                                value={formData.work_type}
                                className="input-field"
                                onChange={(e) =>
                                    setFormData({
                                        ...formData,
                                        work_type: e.target.value
                                    })
                                }
                            >
                                <option value="">
                                    Seleccione...
                                </option>

                                <option value="Excavación">
                                    Excavación
                                </option>

                                <option value="Movimiento de tierra">
                                    Movimiento de tierra
                                </option>

                                <option value="Nivelación">
                                    Nivelación
                                </option>

                                <option value="Relleno">
                                    Relleno
                                </option>

                                <option value="Carguío">
                                    Carguío
                                </option>

                                <option value="Limpieza">
                                    Limpieza
                                </option>

                                <option value="Apertura de camino">
                                    Apertura de camino
                                </option>

                                <option value="Transporte">
                                    Transporte
                                </option>

                                <option value="Compactación">
                                    Compactación
                                </option>

                                <option value="Mantenimiento">
                                    Mantenimiento
                                </option>

                                <option value="Otro">
                                    Otro
                                </option>

                            </select>

                        </div>

                    </div>

                    <div>

                        <label>Ubicación</label>

                        <input

                            value={formData.location}

                            className="input-field"

                            onChange={(e)=>

                                setFormData({

                                    ...formData,

                                    location:e.target.value

                                })

                            }

                        />

                    </div>

                    <div>

                        <label>Descripción</label>

                        <textarea

                            rows={4}

                            className="input-field"

                            value={formData.work_description}

                            onChange={(e)=>

                                setFormData({

                                    ...formData,

                                    work_description:e.target.value

                                })

                            }

                        />

                    </div>

                    <div className="grid lg:grid-cols-2 gap-4">

                        <div>

                            <label>Estado de la Máquina</label>

                            <select
                                value={formData.machine_status}
                                className="input-field"
                                onChange={(e) =>
                                    setFormData({
                                        ...formData,
                                        machine_status: e.target.value
                                    })
                                }
                                required
                            >

                                <option value="">
                                    Seleccione...
                                </option>

                                <option value="operativa">
                                    Operativa
                                </option>

                                <option value="operativa_con_observaciones">
                                    Operativa con observaciones
                                </option>

                                <option value="fuera_de_servicio">
                                    Fuera de servicio
                                </option>

                            </select>

                        </div>

                    </div>

                    <div className="bg-slate-50 rounded-xl border border-slate-200 p-5">

                        <div className="flex items-center gap-2 mb-4">

                            <ClipboardList size={18}/>

                            <div>

                                <h3 className="font-semibold">
                                    Checklist de Máquina
                                </h3>

                                <p className="text-xs text-slate-500">
                                    Marque los puntos revisados antes de iniciar la operación.
                                </p>

                            </div>

                        </div>

                        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">

                            {[
                                ["oil_level", "Nivel de aceite"],
                                ["coolant_level", "Nivel de refrigerante"],
                                ["hydraulic_level", "Nivel hidráulico"],
                                ["visible_leaks", "Fugas visibles"],
                                ["tires_tracks", "Neumáticos / orugas"],
                                ["lights", "Luces"],
                                ["horn", "Bocina"],
                                ["reverse_alarm", "Alarma de retroceso"],
                                ["brakes", "Frenos"],
                                ["general_cleanliness", "Limpieza general"]
                            ].map(([key, label]) => (

                                <label
                                    key={key}
                                    className="flex items-center gap-2 rounded-lg border border-slate-200 bg-white p-3 cursor-pointer"
                                >

                                    <input
                                        type="checkbox"
                                        checked={formData.checklist.includes(key)}
                                        onChange={(e) => {

                                            const checked = e.target.checked;

                                            setFormData(prev => ({
                                                ...prev,
                                                checklist: checked
                                                    ? [...prev.checklist, key]
                                                    : prev.checklist.filter(
                                                        item => item !== key
                                                    )
                                            }));

                                        }}
                                    />

                                    <span className="text-sm">
                                        {label}
                                    </span>

                                </label>

                            ))}

                        </div>

                    </div>

                    {/* ====================================================
                         FOTOGRAFÍAS DE EVIDENCIA
                         ==================================================== */}

                    <div className="bg-slate-50 rounded-xl border border-slate-200 p-5">

                        <div className="flex items-center gap-2 mb-4">

                            <div className="text-lg">
                                📷
                            </div>

                            <div>
                                <h3 className="font-semibold">
                                    Fotografías de Evidencia
                                </h3>

                                <p className="text-xs text-slate-500">
                                    Registre el horómetro y el trabajo realizado.
                                </p>
                            </div>

                        </div>

                        <div className="grid lg:grid-cols-2 gap-5">

                            {/* FOTO HORÓMETRO */}

                            <div className="rounded-xl border border-slate-200 bg-white p-4">

                                <label className="block font-medium mb-2">
                                    📷 Foto del Horómetro
                                </label>

                                <input
                                    type="file"
                                    accept="image/*"
                                    capture="environment"
                                    className="block w-full text-sm text-slate-600
                                        file:mr-4 file:py-2 file:px-4
                                        file:rounded-lg file:border-0
                                        file:text-sm file:font-medium
                                        file:bg-slate-100 file:text-slate-700
                                        hover:file:bg-slate-200"
                                    onChange={(e) => {
                                        const file = e.target.files?.[0] || null;
                                        setHorometerPhoto(file);
                                    }}
                                />

                                {(horometerPhoto || existingHorometerPhoto) && (
                                    <div className="mt-3">

                                        <img
                                            src={
                                                horometerPhoto
                                                    ? URL.createObjectURL(horometerPhoto)
                                                    : existingHorometerPhoto
                                            }
                                            alt="Foto del horómetro"
                                            className="w-full max-h-64 object-contain rounded-lg border border-slate-200 bg-slate-50"
                                        />

                                        <p className="text-xs text-slate-500 mt-2">
                                            {horometerPhoto
                                                ? horometerPhoto.name
                                                : "Fotografía guardada actualmente"}
                                        </p>

                                    </div>
                                )}

                            </div>


                            {/* FOTO TRABAJO */}

                            <div className="rounded-xl border border-slate-200 bg-white p-4">

                                <label className="block font-medium mb-2">
                                    📷 Foto del Trabajo Realizado
                                </label>

                                <input
                                    type="file"
                                    accept="image/*"
                                    capture="environment"
                                    className="block w-full text-sm text-slate-600
                                        file:mr-4 file:py-2 file:px-4
                                        file:rounded-lg file:border-0
                                        file:text-sm file:font-medium
                                        file:bg-slate-100 file:text-slate-700
                                        hover:file:bg-slate-200"
                                    onChange={(e) => {
                                        const file = e.target.files?.[0] || null;
                                        setWorkPhoto(file);
                                    }}
                                />

                                {(workPhoto || existingWorkPhoto) && (
                                    <div className="mt-3">

                                        <img
                                            src={
                                                workPhoto
                                                    ? URL.createObjectURL(workPhoto)
                                                    : existingWorkPhoto
                                            }
                                            alt="Foto del trabajo realizado"
                                            className="w-full max-h-64 object-contain rounded-lg border border-slate-200 bg-slate-50"
                                        />

                                        <p className="text-xs text-slate-500 mt-2">
                                            {workPhoto
                                                ? workPhoto.name
                                                : "Fotografía guardada actualmente"}
                                        </p>

                                    </div>
                                )}

                            </div>

                        </div>

                    </div>


                    <div className="flex justify-end gap-3">

                        <Button

                            type="button"

                            onClick={()=>

                            {

                                resetForm();

                                setDialogOpen(false);
                                setSelectedMachineryData(null);

                            }}

                        >

                            Cancelar

                        </Button>

                        <Button type="submit">

                            {

                                editingReport

                                ?

                                "Actualizar"

                                :

                                "Guardar"

                            }

                        </Button>

                    </div>

                </form>

            </DialogContent>

        </Dialog>

        {/* ====================================================
             MODAL DETALLE DEL PARTE DIARIO - SOLO LECTURA
             ==================================================== */}

        {viewingReport && (
            <Dialog
                open={!!viewingReport}
                onOpenChange={(open) => {
                    if (!open) setViewingReport(null);
                }}
            >
                <DialogContent className="max-w-5xl max-h-[90vh] overflow-y-auto">
                    <DialogHeader>
                        <DialogTitle>
                            Detalle del Parte Diario
                        </DialogTitle>
                    </DialogHeader>

                    <div className="space-y-6">

                        {/* INFORMACIÓN GENERAL */}
                        <div className="bg-slate-50 rounded-xl border border-slate-200 p-5">
                            <h3 className="font-semibold mb-4">
                                Información General
                            </h3>

                            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                                <div>
                                    <p className="text-xs text-slate-500">Fecha</p>
                                    <p className="font-medium">
                                        {viewingReport.date || "-"}
                                    </p>
                                </div>

                                <div>
                                    <p className="text-xs text-slate-500">Maquinaria</p>
                                    <p className="font-medium">
                                        {getMachineryName(viewingReport.machinery_id) || "-"}
                                    </p>
                                </div>

                                <div>
                                    <p className="text-xs text-slate-500">Operador</p>
                                    <p className="font-medium">
                                        {getOperatorName(viewingReport.operator_id) || "-"}
                                    </p>
                                </div>

                                <div>
                                    <p className="text-xs text-slate-500">Proyecto</p>
                                    <p className="font-medium">
                                        {getProjectName(viewingReport.project_id)}
                                    </p>
                                </div>

                                <div>
                                    <p className="text-xs text-slate-500">Tipo de trabajo</p>
                                    <p className="font-medium">
                                        {viewingReport.work_type || "-"}
                                    </p>
                                </div>

                                <div>
                                    <p className="text-xs text-slate-500">Ubicación</p>
                                    <p className="font-medium">
                                        {viewingReport.location || "-"}
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* HORÓMETRO */}
                        <div className="bg-orange-50 rounded-xl border border-orange-200 p-5">
                            <h3 className="font-semibold mb-4">
                                Horómetro
                            </h3>

                            <div className="grid md:grid-cols-3 gap-4">
                                <div>
                                    <p className="text-xs text-slate-500">Inicial</p>
                                    <p className="text-2xl font-bold">
                                        {Number(viewingReport.start_hours || 0).toFixed(1)} h
                                    </p>
                                </div>

                                <div>
                                    <p className="text-xs text-slate-500">Final</p>
                                    <p className="text-2xl font-bold">
                                        {Number(viewingReport.end_hours || 0).toFixed(1)} h
                                    </p>
                                </div>

                                <div>
                                    <p className="text-xs text-slate-500">Horas trabajadas</p>
                                    <p className="text-2xl font-bold text-orange-600">
                                        {Number(viewingReport.hours_worked || 0).toFixed(1)} h
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* COMBUSTIBLE Y FLUIDOS */}
                        <div className="bg-slate-50 rounded-xl border border-slate-200 p-5">
                            <h3 className="font-semibold mb-4">
                                Combustible y Lubricantes / Fluidos
                            </h3>

                            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
                                <div>
                                    <p className="text-xs text-slate-500">
                                        {machinery.find(
                                            m => String(m.id) === String(viewingReport.machinery_id)
                                        )?.fuel_type === "gasolina" ? "Gasolina" : "Diésel"}
                                    </p>
                                    <p className="font-medium">
                                        {Number(viewingReport.diesel_consumed || 0).toFixed(2)} L
                                    </p>
                                </div>

                                <div>
                                    <p className="text-xs text-slate-500">Aceite motor</p>
                                    <p className="font-medium">
                                        {Number(viewingReport.engine_oil_consumed || 0).toFixed(2)} L
                                    </p>
                                </div>

                                <div>
                                    <p className="text-xs text-slate-500">Aceite transmisión</p>
                                    <p className="font-medium">
                                        {Number(viewingReport.transmission_oil_consumed || 0).toFixed(2)} L
                                    </p>
                                </div>

                                <div>
                                    <p className="text-xs text-slate-500">Aceite diferencial</p>
                                    <p className="font-medium">
                                        {Number(viewingReport.differential_oil_consumed || 0).toFixed(2)} L
                                    </p>
                                </div>

                                <div>
                                    <p className="text-xs text-slate-500">Aceite hidráulico</p>
                                    <p className="font-medium">
                                        {Number(viewingReport.hydraulic_oil_consumed || 0).toFixed(2)} L
                                    </p>
                                </div>

                                <div>
                                    <p className="text-xs text-slate-500">Refrigerante</p>
                                    <p className="font-medium">
                                        {Number(viewingReport.coolant_consumed || 0).toFixed(2)} L
                                    </p>
                                </div>

                                <div>
                                    <p className="text-xs text-slate-500">Grasa</p>
                                    <p className="font-medium">
                                        {Number(viewingReport.grease_consumed || 0).toFixed(2)} kg
                                    </p>
                                </div>

                                <div>
                                    <p className="text-xs text-slate-500">Otro fluido</p>
                                    <p className="font-medium">
                                        {Number(viewingReport.other_fluid_consumed || 0).toFixed(2)}
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* OPERACIÓN */}
                        <div className="bg-white rounded-xl border border-slate-200 p-5">
                            <h3 className="font-semibold mb-4">
                                Operación
                            </h3>

                            <div>
                                <p className="text-xs text-slate-500">Descripción del trabajo</p>
                                <p className="mt-1 whitespace-pre-wrap">
                                    {viewingReport.work_description || "-"}
                                </p>
                            </div>
                        </div>

                        {/* ESTADO Y CHECKLIST */}
                        <div className="grid lg:grid-cols-2 gap-5">

                            <div className="bg-white rounded-xl border border-slate-200 p-5">
                                <h3 className="font-semibold mb-4">
                                    Estado de la Máquina
                                </h3>

                                <p className="font-medium">
                                    {viewingReport.machine_status === "operativa"
                                        ? "Operativa"
                                        : viewingReport.machine_status === "operativa_con_observaciones"
                                        ? "Operativa con observaciones"
                                        : viewingReport.machine_status === "fuera_de_servicio"
                                        ? "Fuera de servicio"
                                        : "-"}
                                </p>
                            </div>

                            <div className="bg-white rounded-xl border border-slate-200 p-5">
                                <h3 className="font-semibold mb-4">
                                    Checklist
                                </h3>

                                {Array.isArray(viewingReport.checklist) &&
                                viewingReport.checklist.length > 0 ? (
                                    <div className="grid sm:grid-cols-2 gap-2">
                                        {viewingReport.checklist.map((item) => (
                                            <div
                                                key={item}
                                                className="flex items-center gap-2 text-sm"
                                            >
                                                <span className="text-green-600">✓</span>
                                                <span>{item}</span>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <p className="text-sm text-slate-500">
                                        No se registró checklist.
                                    </p>
                                )}
                            </div>

                        </div>

                        {/* OBSERVACIONES */}
                        {viewingReport.observations && (
                            <div className="bg-yellow-50 rounded-xl border border-yellow-200 p-5">
                                <h3 className="font-semibold mb-2">
                                    Observaciones
                                </h3>

                                <p className="whitespace-pre-wrap">
                                    {viewingReport.observations}
                                </p>
                            </div>
                        )}

                        {/* FOTOGRAFÍAS */}
                        {(viewingReport.horometer_photo || viewingReport.work_photo) && (
                            <div className="bg-slate-50 rounded-xl border border-slate-200 p-5">
                                <h3 className="font-semibold mb-4">
                                    📷 Fotografías de Evidencia
                                </h3>

                                <div className="grid md:grid-cols-2 gap-5">

                                    {viewingReport.horometer_photo && (
                                        <div>
                                            <p className="text-sm font-medium mb-2">
                                                Horómetro
                                            </p>
                                            <img
                                                src={viewingReport.horometer_photo?.startsWith("/uploads/") ? `${API.replace("/api","")}${viewingReport.horometer_photo}` : viewingReport.horometer_photo}
                                                alt="Horómetro"
                                                className="w-full max-h-96 object-contain rounded-xl border border-slate-200 bg-white"
                                            />
                                        </div>
                                    )}

                                    {viewingReport.work_photo && (
                                        <div>
                                            <p className="text-sm font-medium mb-2">
                                                Trabajo realizado
                                            </p>
                                            <img
                                                src={viewingReport.work_photo?.startsWith("/uploads/") ? `${API.replace("/api","")}${viewingReport.work_photo}` : viewingReport.work_photo}
                                                alt="Trabajo realizado"
                                                className="w-full max-h-96 object-contain rounded-xl border border-slate-200 bg-white"
                                            />
                                        </div>
                                    )}

                                </div>
                            </div>
                        )}

                        <div className="flex justify-end gap-3">
                            <Button
                                variant="outline"
                                onClick={() => exportDailyReportPDF(viewingReport)}
                            >
                                📄 PDF
                            </Button>

                            <Button
                                variant="outline"
                                onClick={() => setViewingReport(null)}
                            >
                                Cerrar
                            </Button>
                        </div>

                    </div>
                </DialogContent>
            </Dialog>
        )}

    </div>

    {/* CENTRO DE OPERACIONES — CABECERA */}
    <div className="space-y-5">

        {/* ENCABEZADO */}
        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
            <div className="px-6 py-5 flex flex-col xl:flex-row xl:items-center xl:justify-between gap-5">
                <div>
                    <div className="flex items-center gap-3">
                        <div className="w-11 h-11 rounded-xl bg-orange-100 flex items-center justify-center">
                            <ClipboardList className="w-6 h-6 text-orange-600" />
                        </div>
                        <div>
                            <h1 className="text-2xl font-black text-slate-900">
                                Partes Diarios
                            </h1>
                            <p className="text-sm text-slate-500 mt-0.5">
                                Control operativo de maquinaria y jornadas de trabajo
                            </p>
                        </div>
                    </div>
                </div>

                <div className="flex items-center gap-2">
                    <Button
                        onClick={() => {
                            setEditingReport(null);
                            resetForm();
                            setDialogOpen(true);
                        }}
                        className="bg-orange-600 hover:bg-orange-700 text-white shadow-sm px-5"
                    >
                        + Nuevo Parte
                    </Button>
                </div>
            </div>

            {/* KPIs */}
            <div className="border-t border-slate-100 px-6 py-4 bg-slate-50/70">
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">

                    <div className="bg-white rounded-xl border border-slate-200 px-4 py-3">
                        <p className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">Total Partes</p>
                        <p className="text-2xl font-black text-slate-900 mt-1">{stats.reports}</p>
                    </div>

                    <div className="bg-white rounded-xl border border-slate-200 px-4 py-3">
                        <p className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">Horas</p>
                        <p className="text-2xl font-black text-blue-600 mt-1">{stats.hours.toFixed(1)}</p>
                    </div>

                    <div className="bg-white rounded-xl border border-slate-200 px-4 py-3">
                        <p className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">Diésel</p>
                        <p className="text-2xl font-black text-orange-600 mt-1">{stats.diesel.toFixed(1)} L</p>
                    </div>

                    <div className="bg-white rounded-xl border border-slate-200 px-4 py-3">
                        <p className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">Maquinarias</p>
                        <p className="text-2xl font-black text-emerald-600 mt-1">{stats.machines}</p>
                    </div>

                    <div className="bg-white rounded-xl border border-slate-200 px-4 py-3">
                        <p className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">Operadores</p>
                        <p className="text-2xl font-black text-violet-600 mt-1">{stats.operators}</p>
                    </div>

                </div>
            </div>
        </div>

        {/* FILTROS */}
        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm">
            <div className="px-6 py-4 border-b border-slate-100 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3">
                <div>
                    <h2 className="text-base font-bold text-slate-900">Filtros y búsqueda</h2>
                    <p className="text-xs text-slate-500 mt-0.5">
                        {filteredReports.length} registro{filteredReports.length !== 1 ? "s" : ""} encontrado{filteredReports.length !== 1 ? "s" : ""}
                    </p>
                </div>

                <div className="flex items-center gap-2">
                    <Button
                        variant="outline"
                        size="sm"
                        onClick={exportExcel}
                    >
                        📊 Excel
                    </Button>
                    <Button
                        variant="outline"
                        size="sm"
                        onClick={exportPDF}
                    >
                        📄 PDF
                    </Button>
                </div>
            </div>

            <div className="p-6">
                <div className="grid xl:grid-cols-4 lg:grid-cols-2 gap-4">

                    <div>
                        <label className="block text-xs font-semibold text-slate-600 mb-1.5">Buscar</label>
                        <input
                            type="text"
                            placeholder="Maquinaria, operador..."
                            className="input-field"
                            value={search}
                            onChange={(e)=>setSearch(e.target.value)}
                        />
                    </div>

                    <div>
                        <label className="block text-xs font-semibold text-slate-600 mb-1.5">Período</label>
                        <select
                            className="input-field"
                            value={viewMode}
                            onChange={(e)=>setViewMode(e.target.value)}
                        >
                            <option value="day">📅 Hoy</option>
                            <option value="week">🗓 Esta semana</option>
                            <option value="month">📆 Este mes</option>
                            <option value="year">🗂 Este año</option>
                            <option value="custom">📌 Personalizado</option>
                            <option value="all">📋 Historial completo</option>
                        </select>
                    </div>

                    <div>
                        <label className="block text-xs font-semibold text-slate-600 mb-1.5">Maquinaria</label>
                        <select
                            className="input-field"
                            value={selectedMachine}
                            onChange={(e)=>setSelectedMachine(e.target.value)}
                        >
                            <option value="">Todas</option>
                            {machinery.map(machine=>(
                                <option key={machine.id} value={machine.id}>{machine.name}</option>
                            ))}
                        </select>
                    </div>

                    <div>
                        <label className="block text-xs font-semibold text-slate-600 mb-1.5">Operador</label>
                        <select
                            className="input-field"
                            value={selectedOperator}
                            onChange={(e)=>setSelectedOperator(e.target.value)}
                        >
                            <option value="">Todos</option>
                            {operators.map(op=>(
                                <option key={op.id} value={op.id}>{op.name}</option>
                            ))}
                        </select>
                    </div>

                </div>

                {viewMode === "custom" && (
                    <div className="grid md:grid-cols-2 gap-4 mt-4 p-4 rounded-xl bg-slate-50 border border-slate-200">
                        <div>
                            <label className="block text-xs font-semibold text-slate-600 mb-1.5">Desde</label>
                            <input
                                type="date"
                                className="input-field"
                                value={fromDate}
                                onChange={(e)=>setFromDate(e.target.value)}
                            />
                        </div>
                        <div>
                            <label className="block text-xs font-semibold text-slate-600 mb-1.5">Hasta</label>
                            <input
                                type="date"
                                className="input-field"
                                value={toDate}
                                onChange={(e)=>setToDate(e.target.value)}
                            />
                        </div>
                    </div>
                )}

                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mt-5 pt-4 border-t border-slate-100">
                    <Button
                        variant="outline"
                        onClick={()=>{
                            setSearch("");
                            setSelectedMachine("");
                            setSelectedOperator("");
                            setViewMode("all");
                            setFromDate("");
                            setToDate("");
                        }}
                    >
                        Limpiar filtros
                    </Button>

                    <div className="flex items-center gap-2">
                        <Button
                            variant="outline"
                            onClick={() => {
                                const d = new Date(currentDate + "T00:00:00");
                                switch (viewMode) {
                                    case "day": d.setDate(d.getDate() - 1); break;
                                    case "week": d.setDate(d.getDate() - 7); break;
                                    case "month": d.setMonth(d.getMonth() - 1); break;
                                    case "year": d.setFullYear(d.getFullYear() - 1); break;
                                    default: return;
                                }
                                setCurrentDate(d.toISOString().split("T")[0]);
                            }}
                            disabled={viewMode === "all" || viewMode === "custom"}
                        >
                            ◀
                        </Button>

                        <Button
                            variant={viewMode === "day" ? "default" : "outline"}
                            onClick={() => {
                                const t = new Date();
                                t.setMinutes(t.getMinutes() - t.getTimezoneOffset());
                                setCurrentDate(t.toISOString().split("T")[0]);
                                setViewMode("day");
                            }}
                        >
                            Hoy
                        </Button>

                        <Button
                            variant="outline"
                            onClick={() => {
                                const d = new Date(currentDate + "T00:00:00");
                                switch (viewMode) {
                                    case "day": d.setDate(d.getDate() + 1); break;
                                    case "week": d.setDate(d.getDate() + 7); break;
                                    case "month": d.setMonth(d.getMonth() + 1); break;
                                    case "year": d.setFullYear(d.getFullYear() + 1); break;
                                    default: return;
                                }
                                setCurrentDate(d.toISOString().split("T")[0]);
                            }}
                            disabled={viewMode === "all" || viewMode === "custom"}
                        >
                            ▶
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    {/* LISTADO */}

    <div className="mt-5 bg-white rounded-2xl border border-slate-200 shadow-sm">
        <div className="px-6 py-4 border-b border-slate-100">
            <h2 className="text-lg font-bold text-slate-900">{header.title}</h2>
            <p className="text-sm text-slate-500 mt-1">{header.subtitle}</p>
        </div>
    </div>

{
    loading ? (
        <div className="bg-white rounded-2xl shadow p-20 text-center">Cargando...</div>
    ) : (
        <div className="space-y-5">

                {

                    filteredReports.map(report => (
                        <div
                            key={report.id}
                            className="bg-white rounded-2xl border border-slate-200 shadow-sm hover:shadow-md transition overflow-hidden"
                        >
                            {/* CABECERA */}
                            <div className="p-4 sm:p-6 border-b border-slate-100">
                                <div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">

                                    <div className="min-w-0">
                                        <div className="flex items-start gap-3">
                                            <div className="w-11 h-11 sm:w-12 sm:h-12 rounded-xl bg-orange-100 flex items-center justify-center shrink-0">
                                                <Truck className="text-orange-600" size={22} />
                                            </div>

                                            <div className="min-w-0">
                                                <h2 className="text-lg sm:text-2xl font-bold text-slate-900 truncate">
                                                    {getMachineryName(report.machinery_id)}
                                                </h2>

                                                <div className="flex flex-col sm:flex-row sm:flex-wrap gap-2 sm:gap-4 mt-2 text-sm text-slate-500">
                                                    <span className="flex items-center gap-1.5">
                                                        <Users size={15} />
                                                        <span className="truncate">
                                                            {getOperatorName(report.operator_id)}
                                                        </span>
                                                    </span>

                                                    <span className="flex items-center gap-1.5">
                                                        <Calendar size={15} />
                                                        {new Date(report.date + "T00:00:00").toLocaleDateString("es-BO")}
                                                    </span>

                                                    {report.location && (
                                                        <span className="flex items-center gap-1.5">
                                                            <MapPin size={15} />
                                                            <span className="truncate">
                                                                {report.location}
                                                            </span>
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-1 mt-4 text-xs text-slate-400">
                                            <div>
                                                <strong className="text-slate-500">Creado:</strong>{" "}
                                                {formatDateTime(report.created_at)}
                                            </div>

                                            <div>
                                                <strong className="text-slate-500">Modificado:</strong>{" "}
                                                {formatDateTime(report.updated_at)}
                                            </div>
                                        </div>
                                    </div>

                                    {/* ACCIONES */}
                                    <div
                                        className="grid grid-cols-1 sm:grid-cols-3 lg:flex lg:items-center gap-2 w-full lg:w-auto shrink-0"
                                    >
                                        {(user.role === "admin" ||
                                            user.role === "supervisor" ||
                                            report.operator_id === user.id) && (
                                            <>
                                                <Button
                                                    type="button"
                                                    variant="default"
                                                    onClick={() => handleViewReport(report)}
                                                    className="w-full lg:w-auto bg-blue-600 hover:bg-blue-700 text-white h-10 px-4"
                                                >
                                                    <Eye size={17} className="mr-2" />
                                                    Ver parte
                                                </Button>

                                                <Button
                                                    type="button"
                                                    variant="outline"
                                                    onClick={() => openEditDialog(report)}
                                                    className="w-full lg:w-auto h-10 px-4"
                                                >
                                                    <Edit size={17} className="mr-2" />
                                                    Editar
                                                </Button>

                                                <Button
                                                    type="button"
                                                    variant="destructive"
                                                    onClick={() => handleDelete(report.id)}
                                                    className="w-full lg:w-auto h-10 px-4"
                                                >
                                                    <Trash2 size={17} className="mr-2" />
                                                    Eliminar
                                                </Button>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* INDICADORES */}
                            <div className="p-4 sm:p-6">
                                <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">

                                    <div className="rounded-xl bg-orange-50 border border-orange-100 p-3 sm:p-5">
                                        <p className="text-xs sm:text-sm text-slate-500">
                                            Horas trabajadas
                                        </p>
                                        <h2 className="text-xl sm:text-3xl font-black text-orange-600 mt-1">
                                            {Number(report.hours_worked || 0).toFixed(1)}
                                        </h2>
                                    </div>

                                    <div className="rounded-xl bg-blue-50 border border-blue-100 p-3 sm:p-5">
                                        <p className="text-xs sm:text-sm text-slate-500">
                                            Diésel
                                        </p>
                                        <h2 className="text-xl sm:text-3xl font-black text-blue-600 mt-1">
                                            {Number(report.diesel_consumed || 0).toFixed(1)} L
                                        </h2>
                                    </div>

                                    <div className="rounded-xl bg-green-50 border border-green-100 p-3 sm:p-5">
                                        <p className="text-xs sm:text-sm text-slate-500">
                                            Aceite
                                        </p>
                                        <h2 className="text-xl sm:text-3xl font-black text-green-600 mt-1">
                                            {Number(report.oil_consumed || 0).toFixed(1)} L
                                        </h2>
                                    </div>

                                    <div className="rounded-xl bg-purple-50 border border-purple-100 p-3 sm:p-5">
                                        <p className="text-xs sm:text-sm text-slate-500">
                                            Horómetro
                                        </p>
                                        <h2 className="text-base sm:text-xl font-bold text-slate-800 mt-1">
                                            {report.start_hours}
                                            {" → "}
                                            {report.end_hours}
                                        </h2>
                                    </div>

                                </div>

                                {/* TRABAJO REALIZADO */}
                                <div className="mt-5">
                                    <div className="font-semibold text-sm sm:text-base text-slate-800 mb-2">
                                        Trabajo realizado
                                    </div>

                                    <div className="rounded-xl bg-slate-50 border border-slate-100 p-3 sm:p-5 text-sm sm:text-base leading-6 sm:leading-7 text-slate-700">
                                        {report.work_description || "Sin descripción registrada."}
                                    </div>
                                </div>

                                {/* COMBUSTIBLE DESCONTADO */}
                                {report.fuel_load_id && (
                                    <div className="mt-4 rounded-xl bg-green-50 border border-green-200 p-3 sm:p-4 flex items-start sm:items-center gap-3 text-sm text-green-800">
                                        <Fuel
                                            className="text-green-700 shrink-0"
                                            size={20}
                                        />

                                        <span>
                                            El consumo fue descontado automáticamente del módulo de combustible.
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))
                }

                {

                    filteredReports.length===0 &&

                    <div className="bg-white rounded-2xl shadow p-20 text-center">

                        No existen partes diarios registrados.

                    </div>

                }

            </div>

        )

    }

</div>

);

};


export default DailyReports;